import { Link } from "react-router-dom"

const CartWidget = () => {
  return (
    <div className="dropdown dropdown-end">
    <label tabindex="0" className="btn btn-ghost btn-circle">
      <div className="indicator">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
        <span className="badge badge-sm indicator-item bg-green-400 text-black text-lg">0</span>
      </div>
    </label>
    <div tabindex="0" className="mt-3 card card-compact dropdown-content bg-stone-900 shadow">
      <div className="card-body w-80">
        <span className="text-lg text-white">El carrito está vacio</span>
        <span className="text-right text-emerald-900 text-2xl">Subtotal: $0</span>
        <div className="card-actions">
          <Link className="btn bg-emerald-900 btn-block text-orange-100 hover:text-white hover:bg-red-800" to={`/Cart/`}>Finalizar Compra</Link>
        </div>
      </div>
    </div>
  </div>
  )
}
export default CartWidget